package xim.poc.game.configuration.v0.tactics

import xim.poc.ActorManager
import xim.poc.audio.SystemSound
import xim.poc.browser.GameKey
import xim.poc.game.MiscEffects
import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.v0.TacticsUnit
import xim.poc.ui.ShiftJis
import xim.resource.DatId

class TacticsJobChangeUi(val unit: TacticsUnit, val parent: TacticsBookInteraction, val zone: TacticsZoneInstance) {

    fun push() {
        UiStateHelper.openQueryMode(
            promptProvider = { "Which job?" },
            optionsProvider = { getJobChangeOptions(unit) },
            drawFn = { drawUnitWithJob(unit, it) },
            childStates = { listOf(TacticsSkillPreview.skillPreview) },
            visibleOptions = 6,
            keyHandler = {
                TacticsSkillPreview.skillPreview.resetCursorIndex()

                if (UiStateHelper.keyPressed(GameKey.UiRight)) {
                    UiStateHelper.pushState(TacticsSkillPreview.skillPreview, SystemSound.TargetCycle)
                    true
                } else {
                    false
                }
            }
        ) {
            handleJobChange(unit, it)
        }
    }

    private fun getJobChangeOptions(unit: TacticsUnit): List<QueryMenuOption> {
        val (_, missedJobs) = unit.unlockJobs()

        val validJobOptions = unit.jobLevels.map {
            val color = if (it.key == unit.currentJob) { ShiftJis.colorItem } else { ShiftJis.colorWhite }
            val optionText = "${color}${TacticsJobConfigs[it.key].displayName}${ShiftJis.colorClear} Lv.${it.value.level}"
            QueryMenuOption(optionText, it.key.id)
        }

        val invalidJobOptions = ArrayList<QueryMenuOption>()
        for (jobId in missedJobs) {
            val jobConfig = TacticsJobConfigs[jobId]
            val unlockString = jobConfig.evolveRequirements.joinToString(transform = this::evolutionToString)
            invalidJobOptions += QueryMenuOption("${ShiftJis.colorGrey}Reach: $unlockString", jobId.id)
        }

        return (validJobOptions + invalidJobOptions).sortedBy { it.value } + QueryMenuOption("Cancel", -1)
    }

    private fun handleJobChange(unit: TacticsUnit, option: QueryMenuOption?): QueryMenuResponse {
        if (option == null || option.value < 0) { return QueryMenuResponse.pop }

        val newJob = TacticsJobId(option.value)
        if (newJob == unit.currentJob) { return QueryMenuResponse.noop }

        if (!unit.jobLevels.contains(newJob)) {
            return QueryMenuResponse.noop(SystemSound.Invalid)
        }

        unit.currentJob = newJob
        playChangeJobEffect()

        return QueryMenuResponse.noop
    }

    private fun drawUnitWithJob(unit: TacticsUnit, queryMenuOption: QueryMenuOption) {
        if (queryMenuOption.value < 0) {
            TacticsSkillPreview.currentJobId = null
            return
        }

        val job = TacticsJobId(queryMenuOption.value)
        TacticsSkillPreview.currentJobId = job

        parent.drawUnit(unit = unit, jobId = job)
    }

    private fun playChangeJobEffect() {
        val dummy = ActorManager[zone.portraitDummy.promise.getIfReady()] ?: return
        MiscEffects.playEffect(actor = dummy, target = dummy, fileTableIndex = 0x13A5, effectId = DatId.main)
    }

    private fun evolutionToString(evolution: TacticsEvolution): String {
        return when (evolution) {
            is TacticsUnitEvolution -> "Unit Lv.${evolution.unlockLevel}"
            is TacticsJobEvolution -> {
                val requiredJobConfig = TacticsJobConfigs[evolution.unlockJobId]
                "${requiredJobConfig.displayName} Lv.${evolution.unlockLevel}"
            }
        }
    }

}